import { CommonModule } from '@angular/common';
import { Component, Output, EventEmitter, Input } from '@angular/core';
import { MenuItemComponent } from '../../units/zikata-menu-item/zikata-menu-item.component';
import { saxGraphOutline } from '@ng-icons/iconsax/outline';

@Component({
  selector: 'zikatagov-sidebar-menu',
  template: `
    <ul class="nav flex-column">
      <zikatagov-menu-item
        *ngFor="let item of menuItems"
        [iconName]="item.iconName"
        [caption]="item.caption"
        [showOnlyIcons]="showOnlyIcons"
        [isActive]="item.id === activeItemId"
        (itemClick)="onItemClick(item.id)"
      >
      </zikatagov-menu-item>
    </ul>
  `,
  standalone: true,
  imports: [CommonModule, MenuItemComponent],
  styles: [
    `
      .nav {
        width: 100%;
      }
    `,
  ],
})
export class SidebarMenuComponent {
  @Input() showOnlyIcons = false;
  @Input() activeItemId: number | null = null;
  @Output() menuItemClick = new EventEmitter<number>();

  menuItems = [
    { id: 116, iconName: 'saxGraphOutline', caption: 'Summary' },
    { id: 0, iconName: 'saxHome2Outline', caption: 'Home' },
    { id: 11, iconName: 'saxSetting5Outline', caption: 'Bulk SMS' },

    // { id: 115, iconName: 'saxDeviceMessageOutline', caption: 'Bulk WhatsApp' },
    { id: 10, iconName: 'saxProfile2userOutline', caption: 'Contact Groups' },
    {
      id: 5,
      iconName: 'saxArrowSwapHorizontalOutline',
      caption: 'Transactions',
    },
    { id: 6, iconName: 'saxProfile2userOutline', caption: 'Users' },
    { id: 4, iconName: 'saxCodeOutline', caption: 'Developer' },
    { id: 3, iconName: 'saxUserOutline', caption: 'Applications' },
    { id: 9, iconName: 'saxNotificationOutline', caption: 'Alerts' },
    { id: 12, iconName: 'saxSendOutline', caption: 'Surveys' },
    /*  { id: 7, iconName: 'saxBookOutline', caption: 'Contacts' }, */
  ];

  onItemClick(id: number) {
    this.menuItemClick.emit(id);
  }
}
